import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { useField } from "react-final-form";
import { SelectInput } from "@vk-hr-tek/ui/input";
import { compose } from "../validation/index.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function SelectInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else SelectInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const handleChange = (input, onChange)=>(value)=>{
        input.onChange(value);
        if (onChange) onChange(value);
    };
const SelectInput_SelectInput = (t0)=>{
    const $ = c(77);
    let defaultValue;
    let emptyOption;
    let items;
    let label;
    let labelIcon;
    let name;
    let onChange;
    let placeholder;
    let renderOption;
    let rest;
    let t1;
    let t10;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    let testId;
    let tooltip;
    let validate;
    if ($[0] !== t0) {
        ({ label, labelIcon, tooltip, name, onChange, placeholder, showError: t1, required: t2, disabled: t3, autocomplete: t4, clearable: t5, loading: t6, multiple: t7, items, defaultValue, renderOption, testId, emptyOption, validate, validationWithoutTouch: t8, validationWhenDisabled: t9, withoutMargins: t10 } = t0), rest = _object_without_properties(t0, [
            "label",
            "labelIcon",
            "tooltip",
            "name",
            "onChange",
            "placeholder",
            "showError",
            "required",
            "disabled",
            "autocomplete",
            "clearable",
            "loading",
            "multiple",
            "items",
            "defaultValue",
            "renderOption",
            "testId",
            "emptyOption",
            "validate",
            "validationWithoutTouch",
            "validationWhenDisabled",
            "withoutMargins"
        ]);
        $[0] = t0;
        $[1] = defaultValue;
        $[2] = emptyOption;
        $[3] = items;
        $[4] = label;
        $[5] = labelIcon;
        $[6] = name;
        $[7] = onChange;
        $[8] = placeholder;
        $[9] = renderOption;
        $[10] = rest;
        $[11] = t1;
        $[12] = t10;
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
        $[21] = testId;
        $[22] = tooltip;
        $[23] = validate;
    } else {
        defaultValue = $[1];
        emptyOption = $[2];
        items = $[3];
        label = $[4];
        labelIcon = $[5];
        name = $[6];
        onChange = $[7];
        placeholder = $[8];
        renderOption = $[9];
        rest = $[10];
        t1 = $[11];
        t10 = $[12];
        t2 = $[13];
        t3 = $[14];
        t4 = $[15];
        t5 = $[16];
        t6 = $[17];
        t7 = $[18];
        t8 = $[19];
        t9 = $[20];
        testId = $[21];
        tooltip = $[22];
        validate = $[23];
    }
    const showError = void 0 === t1 ? true : t1;
    const required = void 0 === t2 ? false : t2;
    const disabled = void 0 === t3 ? false : t3;
    const autocomplete = void 0 === t4 ? false : t4;
    const clearable = void 0 === t5 ? false : t5;
    const loading = void 0 === t6 ? false : t6;
    const multiple = void 0 === t7 ? false : t7;
    const validationWithoutTouch = void 0 === t8 ? false : t8;
    const validationWhenDisabled = void 0 === t9 ? false : t9;
    const withoutMargins = void 0 === t10 ? false : t10;
    let t11;
    if ($[24] !== validate) {
        t11 = Array.isArray(validate) ? compose(validate) : validate;
        $[24] = validate;
        $[25] = t11;
    } else t11 = $[25];
    let t12;
    if ($[26] !== defaultValue || $[27] !== rest || $[28] !== t11) {
        t12 = _object_spread({
            initialValue: defaultValue,
            validate: t11
        }, rest);
        $[26] = defaultValue;
        $[27] = rest;
        $[28] = t11;
        $[29] = t12;
    } else t12 = $[29];
    const { input, meta } = useField(name, t12);
    const errorDisabled = disabled || !validationWhenDisabled;
    const renderError = !errorDisabled && validationWithoutTouch ? !!input.value && !!meta.error : meta.touched && !!meta.error;
    if (multiple) {
        let t13;
        if ($[30] !== input || $[31] !== onChange) {
            t13 = handleChange(input, onChange);
            $[30] = input;
            $[31] = onChange;
            $[32] = t13;
        } else t13 = $[32];
        const t14 = input.value;
        const t15 = renderError && showError && meta.error;
        let t16;
        if ($[33] !== autocomplete || $[34] !== clearable || $[35] !== disabled || $[36] !== emptyOption || $[37] !== input || $[38] !== items || $[39] !== label || $[40] !== labelIcon || $[41] !== loading || $[42] !== placeholder || $[43] !== renderError || $[44] !== renderOption || $[45] !== required || $[46] !== t13 || $[47] !== t14 || $[48] !== t15 || $[49] !== testId || $[50] !== tooltip || $[51] !== withoutMargins) {
            t16 = /*#__PURE__*/ jsx(SelectInput, _object_spread_props(_object_spread({}, input), {
                multiple: true,
                label: label,
                labelIcon: labelIcon,
                onChange: t13,
                placeholder: placeholder,
                value: t14,
                items: items,
                required: required,
                disabled: disabled,
                autocomplete: autocomplete,
                clearable: clearable,
                loading: loading,
                error: renderError,
                helperText: t15,
                tooltip: tooltip,
                renderOption: renderOption,
                testId: testId,
                emptyOption: emptyOption,
                withoutMargins: withoutMargins
            }));
            $[33] = autocomplete;
            $[34] = clearable;
            $[35] = disabled;
            $[36] = emptyOption;
            $[37] = input;
            $[38] = items;
            $[39] = label;
            $[40] = labelIcon;
            $[41] = loading;
            $[42] = placeholder;
            $[43] = renderError;
            $[44] = renderOption;
            $[45] = required;
            $[46] = t13;
            $[47] = t14;
            $[48] = t15;
            $[49] = testId;
            $[50] = tooltip;
            $[51] = withoutMargins;
            $[52] = t16;
        } else t16 = $[52];
        return t16;
    }
    let t13;
    if ($[53] !== input || $[54] !== onChange) {
        t13 = handleChange(input, onChange);
        $[53] = input;
        $[54] = onChange;
        $[55] = t13;
    } else t13 = $[55];
    const t14 = input.value;
    const t15 = renderError && showError && meta.error;
    let t16;
    if ($[56] !== autocomplete || $[57] !== clearable || $[58] !== disabled || $[59] !== emptyOption || $[60] !== input || $[61] !== items || $[62] !== label || $[63] !== labelIcon || $[64] !== loading || $[65] !== multiple || $[66] !== placeholder || $[67] !== renderError || $[68] !== renderOption || $[69] !== required || $[70] !== t13 || $[71] !== t14 || $[72] !== t15 || $[73] !== testId || $[74] !== tooltip || $[75] !== withoutMargins) {
        t16 = /*#__PURE__*/ jsx(SelectInput, _object_spread_props(_object_spread({}, input), {
            label: label,
            labelIcon: labelIcon,
            onChange: t13,
            placeholder: placeholder,
            value: t14,
            items: items,
            required: required,
            disabled: disabled,
            autocomplete: autocomplete,
            clearable: clearable,
            loading: loading,
            multiple: multiple,
            error: renderError,
            helperText: t15,
            tooltip: tooltip,
            renderOption: renderOption,
            testId: testId,
            emptyOption: emptyOption,
            withoutMargins: withoutMargins
        }));
        $[56] = autocomplete;
        $[57] = clearable;
        $[58] = disabled;
        $[59] = emptyOption;
        $[60] = input;
        $[61] = items;
        $[62] = label;
        $[63] = labelIcon;
        $[64] = loading;
        $[65] = multiple;
        $[66] = placeholder;
        $[67] = renderError;
        $[68] = renderOption;
        $[69] = required;
        $[70] = t13;
        $[71] = t14;
        $[72] = t15;
        $[73] = testId;
        $[74] = tooltip;
        $[75] = withoutMargins;
        $[76] = t16;
    } else t16 = $[76];
    return t16;
};
const form_SelectInput_SelectInput = SelectInput_SelectInput;
export default form_SelectInput_SelectInput;
